<template>
  <!-- 个人中心 订单详情列表 -->
  <div id="ask-order">
    <!-- title -->
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text">问诊咨询</p>
      <p class="right-text" v-show="isDelect" @click="isDelect = false">完成</p>
      <div v-if="orderList.length>0">
        <img
          src="../../assets/img/login-img/3-3file-delectic@2x.png"
          alt=""
          class="right-icon"
          @click="isDelect = true"
          v-show="!isDelect"
        >
      </div>
    </div>
    <!-- end -->
    <div class="order-scroll ask-order" ref="orderScrollRef">
      <!-- <ul class="order-wrapper" @touchmove="handleTouchMove"> -->
      <ul class="order-wrapper">
        <li v-for="(item ,index) in orderList" :key="index" class="item-box">
          <div class="content-box">
            <div class="select-button-box" v-show="isDelect" @click="onClick(item,index)">
              <img
                src="../../assets/img/login-img/3-4file-select@2x.png"
                alt=""
                class="select-button"
                v-show="delectList.includes(item.order_id)"
              >
              <img
                src="../../assets/img/login-img/3-4file-noselect.png"
                alt=""
                class="select-button"
                v-show="!delectList.includes(item.order_id)"
              >
            </div>
            <div class="box-wrapper" @click="goRouter('/SdAskChat',item)">
              <div class="order-box">
                <div class="order-top">
                  <div class="top-tips">
                    <div class="tips-left">
                      <span>{{item.create_time}}</span>
                      <span class="flag">咨询费用：{{item.order_amount/100}}元</span>
                    </div>
                    <div
                      class="tips-right"
                      :class="{statusRed:item.status === '待支付',statusGreen:item.status === '处理中'}"
                    >
                      <span>{{item.status}}</span>
                    </div>
                  </div>
                  <div class="top-text">
                    <!-- <span>消息:</span> -->
                    <span>{{item.user_question || '暂无'}}</span>
                  </div>
                </div>
                <div class="order-bottom">
                  <div class="order-icon">
                    <div v-if="item.num>0" class="number-box">
                      <span>{{item.num}}</span>
                    </div>
                    <img
                      :src="item.xz_doctor_image || item.doctor_image"
                      v-if="item.status === '已完成'"
                      alt=""
                      class="order-icon"
                    >
                    <img
                      :src="item | imgIng"
                      v-if="item.status === '处理中'"
                      alt=""
                      class="order-icon"
                    >
                    <!-- <img src="../../assets/img/order-img/QJ6724675861 拷贝@2x.png" v-if="item.status === '处理中' && !(item.doctor_image)" alt="" class="order-icon"> -->
                    <!-- <img :src="item." v-if="item.status === '处理中' && !(item.doctor_image)" alt="" class="order-icon"> -->

                    <img
                      :src="item.xz_doctor_image | imgUrl"
                      v-if="item.status === '待支付'"
                      alt=""
                      class="order-icon"
                    >
                    <!-- <img src="../../assets/img/order-img/tuikuan.png" v-if="item.status === '已退款' || item.status === '已取消'" alt="" class="order-icon"> -->

                    <img
                      :src="item | imgIng"
                      v-if="item.status === '已退款' || item.status === '已取消'"
                      alt=""
                      class="order-icon"
                    >
                  </div>
                  <div class="order-msg">
                    <div class="order-doctor">
                      <span class="doctor-name">{{item.doctor_name || item.xz_doctor_name}}</span>
                      <span
                        class="doctor-good"
                        v-if="item.is_famous_doctor==='y'"
                      >{{item.is_famous_doctor}}</span>
                    </div>
                    <div class="order-replay">{{item | textFilter}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 缺省页 -->
    <div class="null-wrapper" v-if="orderList.length===0 && showNull">
      <div class="img-wrapper">
        <img src="../../assets/img/queshengye/no-item@2x.png" alt="" class="null-img">
      </div>
      <div class="text-wrapper">
        <span class="null-text">您还没咨询过呢，给深读君一个伺候您的机会呗!</span>
      </div>
      <div class="button-wrapper">
        <van-button class="null-button" type="primary" @click="goAsk('/SdAskDoctor')">咨询医生</van-button>
      </div>
    </div>
    <!-- end -->
    <!-- bottom -->
    <div class="bottom-button" v-if="isDelect">
      <div class="bottom-left" v-show="true" @click="allSelect">
        <img
          src="../../assets/img/login-img/3-4file-noselect.png"
          alt=""
          class="select-icon"
          v-show="!allSelectFlag"
        >
        <img
          src="../../assets/img/login-img/3-4file-select@2x.png"
          alt=""
          class="select-icon"
          v-show="allSelectFlag"
        >
        <p class="select-text siyuan-bold">全选</p>
      </div>
      <div class="bottom-right">
        <van-button size="large" class="right-button" @click="onSubmit">删除</van-button>
      </div>
    </div>
    <!-- end -->
    <div class="bottom-text" v-if="showBottom">
      <span>深读医生等着你来问，music!</span>
    </div>
  </div>
</template>

<script>
  import BScroll from "better-scroll";
  import api from "@/api/index";
  export default {
    data() {
      return {
        isDelect: false,
        orderList: [],
        delectList: [],
        allSelectFlag: false,
        showPay: false, // 控制从新支付提示
        order_number: "",
        orderItem: {},
        showBottom: false,
        showNull: false,
        backPath: "",
        orderScroll: null,
        orderParams: {
          page: 1,
          number: 5
        }
      };
    },
    updated() {
      // this.showTips()
    },
    beforeMount() {
      this.fetch();
      this.showTips();
    },
    mounted() {
      //alert(localStorage.getItem("token"))
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    beforeRouteLeave(to, from, next) {
      if (to.path === "/SdInquiry") {
        this.backPath = "/SdAskDoctor";
        // this.$router.push('/SdAskDoctor')
        next();
      } else {
        next();
      }
      if (to.path === "/SdAskOrder") {
        this.backPath = "/SdUserInfo";
        // this.$router.push('/SdUserInfo')
        next();
      } else {
        next();
      }
    },
    methods: {
      // 初始化滚动
      initScroll() {
        const options = {
          click: true,
          // pullDownRefresh: {},
          probeType: 2
        };
        options.pullUpLoad = {
          threshold: -90,
          stop: -20
        };
        this.orderScroll = new BScroll(this.$refs.orderScrollRef, options);
        this.orderScroll.on("pullingUp", () => {
          this.pagingSearch();
          this.orderScroll.finishPullUp();
        });
      },
      // 分页
      pagingSearch() {
        this.orderParams.page++;
        this.fetch();
      },
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else if (this.backPath) {
          this.$router.push(this.backPath);
        } else {
          this.$router.go(-1);
        }
      },
      fetch(val) {
        let url = `${api.orderList}?page=${this.orderParams.page}&number=${
          this.orderParams.number
        }`;
        const toast = this.$toast({
          mask: true,
          message: "正在加载..."
        });
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            toast.clear();
            if (res.data.totalPage > 0) {
              if (this.orderParams.page > res.data.totalPage) {
                this.$toast("已经是最后一页了~");
              } else {
                let arry = res.data.data;
                this.orderList = this.orderList.concat(arry);
                if (val === "delete") {
                  this.orderScroll.scrollTo(0, 0);
                } else {
                  this.orderScroll.scrollTo(0, this.orderScroll.maxScrollY);
                }
              }
            } else {
              this.orderList = res.data.data;
              this.showNull = true;
            }
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      allSelect() {
        this.allSelectFlag = !this.allSelectFlag;
        if (this.allSelectFlag) {
          this.delectList.splice(0);
          this.orderList.map((item, index) => {
            this.delectList.push(item.order_id);
          });
        } else {
          this.delectList.splice(0);
        }
      },
      onSubmit() {
        let url = api.orderDelete;
        let params = {
          order_ids: this.delectList.toString()
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("删除成功");
            this.orderParams.page = 1;
            this.orderList = [];
            this.fetch("delete");
            this.delectList = [];
            this.allSelectFlag = false;
            this.isDelect = false;
            localStorage.removeItem("askData");
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      onClick(item) {
        let flag = this.delectList.indexOf(item.order_id);
        if (flag === -1) {
          this.delectList.push(item.order_id);
        } else {
          this.delectList.splice(flag, 1);
        }
      },
      goRouter(val, item) {
        if (item.status === "待支付") {
          this.rePay(item);
          // this.$router.push({ path: val, query: { orderId: item.order_number } })
        } else if (item.status === "处理中" || item.status === "已完成") {
          this.$router.push({ path: val, query: { orderId: item.order_number } });
        } else {
          this.$toast("无效订单");
        }
      },
      goAsk(val) {
        this.$router.push(val);
      },
      // dialog关闭之前
      beforeClose(action, done) {
        if (action === "confirm") {
          this.payMoney();
          done();
        } else {
          done();
        }
      },
      // 微信支付
      payMoney() {
        let params = {
          order_amount: 1,
          order_number: this.orderItem.order_number,
          openid: localStorage.getItem("openid"),
          cxzf: "y"
        };
        let that = this;
        let url = `${api.createOrder}?order_amount`;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            // 下单成功，调用微信支付js
            this.orderNum = res.data.data.order_number;
            this.http = res.data.data.config.json;
            this.prepayId = res.data.data.config.prepayId;
            let params = {
              appId: this.http.appId,
              nonceStr: this.http.nonceStr,
              package: this.http.package,
              paySign: this.http.paySign,
              signType: this.http.signType,
              timeStamp: this.http.timeStamp
            };
            if (this.prepayId !== "") {
              // eslint-disable-next-line
              WeixinJSBridge.invoke("getBrandWCPayRequest", params, function(
                res
              ) {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  // 如果订单的ask_group_type=1 创建总包问题
                  if (that.orderItem.ask_group_type === "1") {
                    that.creatZbSecond();
                    this.fetch();
                  } else {
                    this.creatDxSecond();
                    this.fetch();
                  }
                } else {
                  this.$toast("支付失败");
                }
              });
            }
          }
        });
      },
      // 创建总包从新支付
      creatZbSecond() {
        let url = api.createPaidProblem;
        let params = {
          order_number: this.orderItem.order_number
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == "0") {
            this.$router.push({
              path: "/SdAskChat",
              query: { orderId: this.order_number }
            });
          }
        });
      },
      // 创建定向从新支付
      creatDxSecond() {
        let url = api.createOrientedProblem;
        let params = {
          order_number: this.orderItem.order_number,
          xz_doctor_id: this.orderItem.xz_doctor_id
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == "0" || res.data.code == 0) {
            this.$toast("定向重新支付成功");
            this.$router.push({
              path: "/SdAskChat",
              query: { orderId: this.order_number }
            });
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      //
      showTips() {
        this.showBottom = document.documentElement.scrollTop > 0;
      },
      // 未支付前往从新支付页面
      rePay(item) {
        this.$router.push({
          path: "/SdInquiry",
          query: { order_number: item.order_number }
        });
      }
    },
    computed: {
      defaultImg() {
        return require("../../assets/img/order-img/default-img.png");
      }
    },
    filters: {
      textFilter(val) {
        if (val.status === "已完成") {
          return val.doctor_reply;
        } else if (val.status === "处理中") {
          return val.doctor_reply || " 请耐心等待回复吧~";
        } else if (val.status === "待支付") {
          return "完成支付就能见到厉害的医生大大喽！";
        } else if (val.status === "已退款" || val.status === "已取消") {
          return "订单已关闭，再约一次呗！";
        }
      },
      imgUrl(val) {
        return val || require("../../assets/img/order-img/no-pay.png");
      },
      imgIng(val) {
        if (val.xz_doctor_image || val.doctor_image) {
          return val.xz_doctor_image || val.doctor_image;
        } else {
          return require("../../assets/img/order-img/default-img.png");
        }
      }
    }
  };
</script>

<style lang="postcss">
  #ask-order {
    height: 100%;
    background-color: #fffffd;
    width: 100%;
    & .top-title {
      width: 100%;
      padding: 27px 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
      & .right-text {
        position: absolute;
        right: 30px;
        color: #37bd37;
        font-size: 30px;
      }
      & .right-icon {
        position: absolute;
        right: 30px;
        width: 32px;
        height: 32px;
      }
    }
    & .order-scroll.ask-order {
      position: absolute;
      top: 88px;
      width: 100%;
      height: 90%;
      overflow: hidden;
    }
    & .order-wrapper {
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
      /* height: 100%; */
      /* margin-top: 88px; */
      padding: 0 30px;
      box-sizing: border-box;
      overflow: hidden;
      /* display: inline-block; */
      padding-bottom: 100px;
      & .item-box {
        margin-top: 48px;
      }
      & .box-wrapper {
        width: 100%;
      }
    }
    & .content-box {
      display: flex;
      align-items: center;
      display: flex;
      width: 100%;
      & .select-button-box {
        & .select-button {
          width: 40px;
          margin-right: 45px;
        }
      }
      & .order-box {
        box-sizing: border-box;
        /* padding: 20px; */
        background: rgba(255, 255, 255, 1);
        box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.05);
        /* box-shadow:0px 3px 6px 0px rgba(0, 0, 0, 0.08); */
        border-radius: 10px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        height: 300px;
        overflow: hidden;
        & .order-top::after {
          position: absolute;
          bottom: 0;
          left: 0;
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(0.3);
        }
        & .order-top {
          position: relative;
          padding: 20px 30px;
          padding-bottom: 30px;
          & .top-tips {
            /* margin: 22px 0; */
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 20px;
            color: rgba(153, 153, 153, 1);
            /* height: 32px; */
            & .flag {
              margin-left: 10px;
            }
            & .tips-right {
              line-height: 24px;
              font-size: 24px;
            }
            & .statusRed {
              color: rgba(255, 0, 0, 1);
            }
            & .statusGreen {
              color: rgba(55, 189, 25, 1);
            }
          }
          & .top-text {
            padding-top: 20px;
            font-size: 28px;
            line-height: 30px;
            color: rgba(153, 153, 153, 1);
            overflow: hidden; /*自动隐藏文字*/
            text-overflow: ellipsis; /*文字隐藏后添加省略号*/
            white-space: nowrap; /*强制不换行*/
            width: 20em; /*不允许出现半汉字截断*/
          }
        }
        & .order-bottom {
          /* padding: 20px; */
          padding: 0 30px;
          margin-top: 30px;
          display: flex;
          align-items: center;
          & .number-box {
            position: absolute;
            background-color: red;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
          }
          & .order-icon {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            /* border: 1px solid #333; */
            /* overflow: hidden; */
            /* background-color: red; */
            margin-right: 30px;
          }
          & .order-msg {
            & .order-doctor {
              display: flex;
              align-items: center;
              & .doctor-name {
                font-size: 30px;
                font-family: SourceHanSansCN-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
              }
              & .doctor-good {
                font-size: 18px;
                color: rgba(255, 208, 49, 1);
                background: rgba(255, 208, 49, 0.1);
                border-radius: 8px;
                margin-left: 10px;
              }
            }
            & .order-replay {
              font-size: 28px;
              color: rgba(51, 51, 51, 1);
              margin-top: 20px;
              font-family: Source Han Sans CN;
              line-height: 35px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /*! autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
    & .null-wrapper {
      display: flex;
      flex-direction: column;
      padding-top: 202px;
      align-items: center;
      & .img-wrapper {
        & .null-img {
          width: 330px;
          height: 330px;
        }
      }
      & .text-wrapper {
        padding-top: 60px;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      & .button-wrapper {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        padding-top: 50px;
        & .null-button {
          height: 88px;
          width: 100%;
          background: rgba(255, 255, 253, 1);
          border: 1px solid rgba(215, 215, 215, 1);
          box-shadow: 0px 0px 0px rgba(5px, 5px, 5px, 0.08);
          border-radius: 40px;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    & .bottom-button {
      width: 100%;
      height: 88px;
      position: fixed;
      bottom: 0;
      margin-top: 88px;
      display: flex;
      border: none;
      background-color: #fffffd;
      z-index: 999999;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .van-button--default {
        background-color: #fffffd;
        border: none;
      }
      & .bottom-left {
        border-right: 1px solid #d7d7d7;
        font-size: 32px;
        color: #666666;
        width: 220px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        & .select-icon {
          margin-right: 20px;
          width: 40px;
        }
      }
      & .bottom-right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        & .right-button {
          font-size: 32px;
          color: #37bd19;
          height: 100%;
        }
      }
    }
    & .activeDelect {
      margin: 0 30px;
    }
    & .onDelete {
      margin-bottom: 50px;
    }
    & .bottom-text {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduAskDoctor/SdAskOrder.vue